/**
 * App-wide default entrepot helpers (backed by AppSetting API, not localStorage).
 * Caches the resolved code_ent in memory for the session.
 */
import { getDefaultEntrepot as fetchDefaultEntrepotApi, setDefaultEntrepot as setDefaultEntrepotApi } from '../models/entrepotAPI';

const LEGACY_LOCALSTORAGE_KEY = 'defaultEntrepot';

let cachedCode = null;
let pendingPromise = null;

// One-time cleanup of the old per-browser localStorage default
try {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(LEGACY_LOCALSTORAGE_KEY);
  }
} catch (_) {
  // ignore
}

/**
 * Fetch the app default entrepot code from the server (cached).
 * @returns {Promise<string|null>}
 */
export const getDefaultEntrepot = async () => {
  if (cachedCode) return cachedCode;
  if (pendingPromise) return pendingPromise;

  pendingPromise = fetchDefaultEntrepotApi()
    .then((entrepot) => {
      cachedCode = entrepot?.code_ent || null;
      return cachedCode;
    })
    .catch((error) => {
      console.error('Error fetching default entrepot:', error);
      return null;
    })
    .finally(() => {
      pendingPromise = null;
    });

  return pendingPromise;
};

/**
 * Persist the app default entrepot (admin) and update cache.
 * @param {string} code_ent
 * @returns {Promise<object>}
 */
export const setDefaultEntrepot = async (code_ent) => {
  const entrepot = await setDefaultEntrepotApi(code_ent);
  cachedCode = entrepot?.code_ent || code_ent || null;
  return entrepot;
};

/**
 * Clear the in-memory cache (e.g. after admin changes default).
 */
export const clearDefaultEntrepotCache = () => {
  cachedCode = null;
  pendingPromise = null;
};
